/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import { renderStatus } from '../../../../../components/v2/cell-renderers/status';
import IntegracaoQuickView from './IntegracaoQuickView';
import {
  getIntegracaoDetail,
  getIntegracaoDisplayChip,
} from '../utils/integracaoStatus';

const IntegracaoChip = ({
  row,
  onOpenNsmp,
  onEnviado,
  podeForcarEnvio,
  participacaoMode,
  userId,
}) => {
  const [open, setOpen] = useState(false);
  const chip = getIntegracaoDisplayChip(row);
  const detail = getIntegracaoDetail(row);

  if (!chip) return null;

  const handleClick = (event) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const content = (
    <Box
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleClick(event);
        }
      }}
      sx={{
        py: 0.5,
        cursor: 'pointer',
        display: 'inline-flex',
        maxWidth: '100%',
        opacity: 0.9,
        transition: 'opacity 0.15s ease',
        '&:hover': { opacity: 1 },
        '& .MuiChip-root': {
          maxWidth: '100%',
          height: 'auto',
          '& .MuiChip-label': {
            whiteSpace: 'normal',
            lineHeight: 1.3,
            py: 0.5,
          },
        },
      }}
    >
      {renderStatus(chip)}
    </Box>
  );

  return (
    <>
      <Tooltip title={detail?.tooltip || 'Clique para detalhes da integração'}>
        {content}
      </Tooltip>
      <IntegracaoQuickView
        row={row}
        open={open}
        onClose={handleClose}
        onOpenNsmp={onOpenNsmp}
        onEnviado={onEnviado}
        podeForcarEnvio={podeForcarEnvio}
        participacaoMode={participacaoMode}
        userId={userId}
      />
    </>
  );
};

IntegracaoChip.propTypes = {
  row: PropTypes.object,
  onOpenNsmp: PropTypes.func,
  onEnviado: PropTypes.func,
  podeForcarEnvio: PropTypes.bool,
  participacaoMode: PropTypes.string,
  userId: PropTypes.string,
};

IntegracaoChip.defaultProps = {
  row: null,
  onOpenNsmp: undefined,
  onEnviado: undefined,
  podeForcarEnvio: false,
  participacaoMode: 'ATIVO',
  userId: null,
};

export default IntegracaoChip;
